module.exports = __webpack_public_path__ + "img/info_2023.882c1a28.png";